import React from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import type { Props } from './types';
import { getTranslations } from './utils';

const Type = ({ simplified, typeKey }: Props) => {
	const { formatMessage } = useIntl();

	const getTypeName = (): string => {
		const translations = getTranslations(simplified);
		if (typeKey) {
			const translation = translations[typeKey];
			return translation ? formatMessage(translation) : '';
		}
		return '';
	};

	return typeKey ? (
		<StyledContainer>
			<TypeNameContainer>{getTypeName()}</TypeNameContainer>
		</StyledContainer>
	) : null;
};

export default Type;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const TypeNameContainer = styled.div({
	width: '100%',
	display: 'block',
	overflow: 'hidden',
	whiteSpace: 'nowrap',
	textOverflow: 'ellipsis',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const Container = styled.div({
	display: 'flex',
	flex: '1 1 auto',
	flexDirection: 'row',
	width: '100%',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	paddingTop: token('space.150'),
	paddingBottom: token('space.150'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const StyledContainer = styled(Container)({
	display: 'flex',
	alignItems: 'center',
});
